export const MEDICAL_DETAILS_TITLE_OVERRIDE =
  'If YES, provide the condition diagnosed, date of diagnosis, test results, any treatments or medications, name and address of provider/facility, and date last seen';

export const sharedCareScoutQuestions: Record<string, PolicyFormQuestion> = {
  // Page 1 & 2 (Coverage Selection)
  applicantName: {
    id: 'applicant-name',
    questionRef: 'applicantName',
    title: 'Applicant Print Name',
    type: 'text',
    required: true,
  },
  applicantDob: {
    id: 'applicant-dob',
    questionRef: 'applicantDob',
    title: 'Date of Birth (mm/dd/yyyy)',
    type: 'date',
    required: true,
    validationType: 'age',
  },
  coverageMaximum: {
    id: 'coverage-maximum',
    questionRef: 'coverageMaximum',
    title: 'Coverage Maximum',
    type: 'radio',
    required: true,
    options: [
      { id: '50000', value: '$50,000' },
      { id: '100000', value: '$100,000' },
      { id: '150000', value: '$150,000' },
      { id: '200000', value: '$200,000' },
      { id: '250000', value: '$250,000' },
    ],
  },
  dailyBenefitAmount: {
    id: 'daily-benefit-amount',
    questionRef: 'dailyBenefitAmount',
    title: 'Daily Benefit Amount',
    type: 'radio',
    required: true,
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
  },
  deductiblePeriod: {
    id: 'deductible-period',
    questionRef: 'deductiblePeriod',
    title: 'Deductible Period',
    type: 'radio',
    required: true,
    options: [
      { id: '90-days', value: '90 Days' },
      { id: '180-days', value: '180 Days' },
    ],
  },
  waiverOfHomeAndCommunityCare: {
    id: 'waiver-home-community',
    questionRef: 'waiverOfHomeAndCommunityCare',
    title: 'Waiver of Home and Community Care Deductible Period Rider',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
    conditional: {
      visible: {
        field: 'deductiblePeriod',
        operator: 'equals',
        value: '90-days',
      },
    },
  },
  nonforfeitureBenefit: {
    id: 'nonforfeiture-benefit',
    questionRef: 'nonforfeitureBenefit',
    title: 'Nonforfeiture Benefit',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes (Accept)' },
      { id: 'no', value: 'No (Decline)' },
    ],
  },
  inflationProtection: {
    id: 'inflation-protection',
    questionRef: 'inflationProtection',
    title: 'Inflation Protection/Benefit Increases',
    type: 'radio',
    required: true,
    options: [
      { id: '1-compound', value: '1% Compound' },
      { id: '3-compound', value: '3% Compound' },
      { id: '5-compound', value: '5% Compound' },
      { id: 'no-increases', value: 'No Increases' },
    ],
  },
  coupleStatus: {
    id: 'couple-status',
    questionRef: 'coupleStatus',
    title: 'Are you in a relationship that meets the definition of a Couple?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  spouseName: {
    id: 'spouse-name',
    questionRef: 'spouseName',
    title: 'Print Spouse/Partner Name',
    type: 'text',
    conditional: {
      visible: {
        field: 'coupleStatus',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'coupleStatus',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  spouseSsn: {
    id: 'spouse-ssn',
    questionRef: 'spouseSsn',
    title: 'Social Security Number',
    type: 'text',
    validationType: 'ssn',
    conditional: {
      visible: {
        field: 'coupleStatus',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  spouseDob: {
    id: 'spouse-dob',
    questionRef: 'spouseDob',
    title: 'Date of Birth (mm/dd/yyyy)',
    type: 'date',
    validationType: 'age',
    conditional: {
      visible: {
        field: 'coupleStatus',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  spouseCoverageNumber: {
    id: 'spouse-coverage-number',
    questionRef: 'spouseCoverageNumber',
    title: 'Existing Coverage Number',
    type: 'text',
    conditional: {
      visible: {
        field: 'coupleStatus',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  premiumPaymentMode: {
    id: 'premiumPaymentMode',
    questionRef: 'premiumPaymentMode',
    title: 'Premium Payment Mode',
    type: 'radio',
    required: true,
    options: [
      { id: 'annual', value: 'Annual (1.0)' },
      { id: 'semiAnnual', value: 'Semi-annual (.51)' },
      { id: 'quarterly', value: 'Quarterly (.26)' },
      { id: 'monthly', value: 'Monthly (.09)' },
    ],
  },
  agentName: {
    id: 'agentName',
    questionRef: 'agentName',
    title: 'Agent Name',
    type: 'text',
  },
  haveAgentProducerCode: {
    id: 'haveAgentProducerCode',
    questionRef: 'haveAgentProducerCode',
    title: 'Do you have an Agent Producer Code with CareScout?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  agentProducerCode: {
    id: 'agentProducerCode',
    questionRef: 'agentProducerCode',
    title: 'Agent Producer Code',
    type: 'text',
    conditional: {
      visible: {
        field: 'haveAgentProducerCode',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'haveAgentProducerCode',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  nationalProducerCode: {
    id: 'nationalProducerCode',
    questionRef: 'nationalProducerCode',
    title:
      'National Producer Code (This may be used to initiate a just-in-time appointment for this application)',
    type: 'text',
    validationType: 'npn',
    conditional: {
      visible: {
        field: 'haveAgentProducerCode',
        operator: 'equals',
        value: 'no',
      },
    },
  },
  applicationSignedState: {
    id: 'applicationSignedState',
    questionRef: 'applicationSignedState',
    title: 'State In Which Application Is Signed',
    type: 'text',
    validationType: 'state',
    placeholder: 'Select state',
  },

  // Page 3 (Electronic Funds Transfer (EFT) Payment Authorization for Long Term Care Insurance)
  applicantNameEft: {
    id: 'applicantNameEft',
    questionRef: 'applicantNameEft',
    title: 'Applicant Print Name',
    type: 'text',
    required: false,
  },

  accountOwnerDifferent: {
    id: 'accountOwnerDifferent',
    questionRef: 'accountOwnerDifferent',
    title: '',
    type: 'multiselect',
    disabled: true,
    options: [{ id: 'yes', value: 'Account owner is not Applicant', tooltip: "To apply with a separate account owner, please apply directly with CareScout."}],
    helperText: "To apply with a separate account owner, please apply directly with CareScout."
  },

  accountOwnerName: {
    id: 'accountOwnerName',
    questionRef: 'accountOwnerName',
    title: 'Account Owner Name',
    type: 'text',
    conditional: {
      visible: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  accountOwnerEmail: {
    // only used for creating docusign role. Not populated in the docusign envelope.
    id: 'accountOwnerEmail',
    questionRef: 'accountOwnerEmail',
    title: 'Email Address',
    type: 'text',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  accountOwnerAddress: {
    id: 'accountOwnerAddress',
    questionRef: 'accountOwnerAddress',
    title: 'Address',
    type: 'text',
    validationType: 'streetAddress',
    conditional: {
      visible: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  accountOwnerCity: {
    id: 'accountOwnerCity',
    questionRef: 'accountOwnerCity',
    title: 'City',
    type: 'text',
    validationType: 'city',
    conditional: {
      visible: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  accountOwnerState: {
    id: 'accountOwnerState',
    questionRef: 'accountOwnerState',
    title: 'State',
    type: 'text',
    validationType: 'state',
    placeholder: 'Select state',
    conditional: {
      visible: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  accountOwnerZipcode: {
    id: 'accountOwnerZipcode',
    questionRef: 'accountOwnerZipcode',
    title: 'Zip Code',
    type: 'text',
    validationType: 'zipcode',
    conditional: {
      visible: {
        field: 'accountOwnerDifferent',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  routingNumber: {
    id: 'routingNumber',
    questionRef: 'routingNumber',
    title: 'Routing Number',
    type: 'text',
    required: false,
  },

  accountNumber: {
    id: 'accountNumber',
    questionRef: 'accountNumber',
    title: 'Account Number',
    type: 'text',
    required: false,
  },

  // Page 5 - 13 (Application for CareScout Care Assurance Individual Long-Term Care Insurance)
  /* Section A - Applicant Profile */
  firstName: {
    id: 'first-name',
    questionRef: 'firstName',
    title: 'First Name',
    type: 'text',
    required: true,
  },
  middleInitial: {
    id: 'middle-initial',
    questionRef: 'middleInitial',
    title: 'Middle Initial',
    type: 'text',
    required: false,
  },
  lastName: {
    id: 'last-name',
    questionRef: 'lastName',
    title: 'Last Name',
    type: 'text',
    required: true,
  },
  applicantPrintName: {
    id: 'applicant-print-name',
    questionRef: 'applicantPrintName',
    title: 'Applicant Print Name',
    type: 'text',
    required: true,
  },
  maritalStatus: {
    id: 'marital-status',
    questionRef: 'maritalStatus',
    title: 'Status',
    type: 'radio',
    required: true,
    options: [
      { id: 'married-legal-partner', value: 'Married/Legal Partner' },
      { id: 'single', value: 'Single' },
    ],
  },
  socialSecurityNumber: {
    id: 'social-security-number',
    questionRef: 'socialSecurityNumber',
    title: 'Social Security number',
    type: 'text',
    required: true,
    validationType: 'ssn',
  },
  driversLicenseNumber: {
    id: 'drivers-license-number',
    questionRef: 'driversLicenseNumber',
    title: "Driver's License/State ID #",
    type: 'text',
    required: true,
  },
  driversLicenseState: {
    id: 'drivers-license-state',
    questionRef: 'driversLicenseState',
    title: "Driver's License State of Issue",
    type: 'text',
    required: true,
    validationType: 'state',
  },
  emailAddress: {
    id: 'email-address',
    questionRef: 'emailAddress',
    title: 'Email Address',
    type: 'text',
    required: true,
    validationType: 'email',
  },
  dateOfBirth: {
    id: 'date-of-birth',
    questionRef: 'dateOfBirth',
    title: 'Date of Birth (mm/dd/yyyy)',
    type: 'date',
    required: true,
  },
  birthplace: {
    id: 'birthplace',
    questionRef: 'birthplace',
    title: 'Birthplace (State/Country)',
    type: 'text',
    required: true,
  },
  gender: {
    id: 'gender',
    questionRef: 'gender',
    title: 'Gender',
    type: 'radio',
    required: true,
    options: [
      { id: 'male', value: 'Male' },
      { id: 'female', value: 'Female' },
    ],
  },
  phoneNumber: {
    id: 'phone-number',
    questionRef: 'phoneNumber',
    title: 'Phone Number',
    type: 'text',
    required: true,
    validationType: 'phone',
  },
  phoneNumberIsCell: {
    id: 'phone-number-is-cell',
    questionRef: 'phoneNumberIsCell',
    title: '',
    type: 'multiselect',
    required: false,
    options: [{ id: 'yes', value: 'Check If Cell Phone' }],
  },
  residenceStreetAddress: {
    id: 'residence-street-address',
    questionRef: 'residenceStreetAddress',
    title: 'Residence Street Address',
    type: 'text',
    required: true,
  },
  residenceCity: {
    id: 'residence-city',
    questionRef: 'residenceCity',
    title: 'City',
    type: 'text',
    required: true,
  },
  residenceState: {
    id: 'residence-state',
    questionRef: 'residenceState',
    title: 'State',
    type: 'text',
    required: true,
    validationType: 'state',
  },
  residenceZipCode: {
    id: 'residence-zip-code',
    questionRef: 'residenceZipCode',
    title: 'Zip Code',
    type: 'text',
    required: true,
    validationType: 'zipcode',
  },
  differentAddress: {
    id: 'different-address',
    questionRef: 'differentAddress',
    title: '',
    type: 'multiselect',
    required: false,
    options: [
      { id: 'yes', value: 'Check if the mailing address is the different from the residence' },
    ],
  },
  mailingAddress: {
    id: 'mailing-address',
    questionRef: 'mailingAddress',
    title: 'Mailing Address (if different from Residence Address)',
    type: 'text',
    validationType: 'streetAddress',
    conditional: {
      visible: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  mailingCity: {
    id: 'mailing-city',
    questionRef: 'mailingCity',
    title: 'City',
    type: 'text',
    validationType: 'city',
    conditional: {
      visible: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  mailingState: {
    id: 'mailing-state',
    questionRef: 'mailingState',
    title: 'State',
    type: 'text',
    conditional: {
      visible: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
    },
    validationType: 'state',
  },
  mailingZipCode: {
    id: 'mailing-zip-code',
    questionRef: 'mailingZipCode',
    title: 'Zip Code',
    type: 'text',
    conditional: {
      visible: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'differentAddress',
        operator: 'equals',
        value: 'yes',
      },
    },
    validationType: 'zipcode',
  },

  /* Section B - Insurability Profile */
  socialSecurityDisability: {
    id: 'social-security-disability',
    questionRef: 'socialSecurityDisability',
    title:
      'Within the past 3 years, have you received Social Security Disability Insurance benefits?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  assistiveDevices: {
    id: 'assistive-devices',
    questionRef: 'assistiveDevices',
    title:
      'Do you use any of the following: walker, motorized scooter, stair lift, wheelchair, quad cane, hospital bed, Hoyer lift, respirator, kidney dialysis or oxygen (not supplemental use with CPAP or BIPAP for sleep apnea)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  adlAssistance: {
    id: 'adl-assistance',
    questionRef: 'adlAssistance',
    title:
      "Do you need any assistance or supervision in performing any of the following activities of daily living (ADL's): moving in/out of bed or chair, bathing, dressing, eating, toileting, bowel/bladder control, or walking?",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  homeCareUse: {
    id: 'home-care-use',
    questionRef: 'homeCareUse',
    title:
      'Do you currently use, or have you been advised by a member of the medical profession to use home care or an adult day care facility?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  ltcFacility: {
    id: 'ltc-facility',
    questionRef: 'ltcFacility',
    title:
      'Do you currently reside in, have you been advised by a member of the medical profession to enter or are you planning to enter any of the following: nursing home, assisted living facility, or any other custodial or long-term care facility?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  seriousConditions: {
    id: 'serious-conditions',
    questionRef: 'seriousConditions',
    title: `Have you ever been diagnosed or advised by a member of the medical profession as having, or in the past 5 years been treated for any of the following conditions:
- Alzheimer's Disease
- Dementia, Senility
- Schizophrenia or other forms of Psychosis
- Amyotrophic Lateral Sclerosis (ALS, also called Lou Gehrig's Disease)
- Multiple Sclerosis (MS)
- Muscular Dystrophy
- Huntington's Disease
- Parkinson's Disease
- Diabetes Type 1
- Diabetes Type 2 with any history of Transient Ischemic Attack (TIA), Heart Attack, Bypass/Angioplasty/Stent surgery of the heart or legs, or Carotid Artery surgery
- TIA within the past 5 years
- TIA two or more times
- TIA in combination with Heart Disease or Heart Surgery
- Stroke
- Organ Transplant (other than Kidney, Cornea or Bone Marrow Transplant)
- Cystic Fibrosis?`,
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  seriousCancers: {
    id: 'serious-cancers',
    questionRef: 'seriousCancers',
    title:
      'In the past 4 years have you had treatment for, been diagnosed or advised by a member of the medical profession as having cancer of the: brain, esophagus, liver, pancreas or stomach?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  /* Section C - Medical Questions */
  primaryCareProviderName: {
    id: 'primary-care-provider-name',
    questionRef: 'primaryCareProviderName',
    title: 'Primary Care Provider Name (if none, state NONE)',
    type: 'text',
    required: true,
  },
  primaryCareProviderAddress: {
    id: 'primary-care-provider-address',
    questionRef: 'primaryCareProviderAddress',
    title: 'Address',
    type: 'text',
    validationType: 'streetAddress',
    conditional: {
      visible: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
      required: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
    },
  },
  primaryCareProviderPhone: {
    id: 'primary-care-provider-phone',
    questionRef: 'primaryCareProviderPhone',
    title: 'Phone Number',
    type: 'text',
    conditional: {
      visible: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
      required: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
    },
    validationType: 'phone',
  },
  primaryCareProviderDateLastSeen: {
    id: 'primary-care-provider-date-last-seen',
    questionRef: 'primaryCareProviderDateLastSeen',
    title: 'Date Last Seen',
    type: 'date',
    conditional: {
      visible: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
      required: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
    },
  },
  primaryCareProviderReasonLastSeen: {
    id: 'primary-care-provider-reason-last-seen',
    questionRef: 'primaryCareProviderReasonLastSeen',
    title: 'Reason Last Seen',
    type: 'text',
    conditional: {
      visible: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
      required: {
        field: 'primaryCareProviderName',
        operator: 'notContains',
        value: 'NONE',
      },
    },
  },
  heightFeet: {
    id: 'height-feet',
    questionRef: 'heightFeet',
    title: 'Height (ft)',
    type: 'number',
    required: true,
  },
  heightInches: {
    id: 'height-inches',
    questionRef: 'heightInches',
    title: 'Height (in)',
    type: 'number',
    required: true,
  },
  weight: {
    id: 'weight',
    questionRef: 'weight',
    title: 'Weight (lbs)',
    type: 'number',
    required: true,
  },
  weightChange: {
    id: 'weight-change',
    questionRef: 'weightChange',
    title: 'Have you lost or gained 15 pounds or more in the past year?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  weightChangeType: {
    id: 'weight-change-type',
    questionRef: 'weightChangeType',
    title: 'Was the weight lost or gained?',
    type: 'radio',
    options: [
      { id: 'lost', value: 'Lost' },
      { id: 'gained', value: 'Gained' },
    ],
    conditional: {
      visible: {
        field: 'weightChange',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'weightChange',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  weightChangePounds: {
    id: 'weight-change-pounds',
    questionRef: 'weightChangePounds',
    title: 'How many pounds?',
    type: 'number',
    conditional: {
      visible: {
        field: 'weightChange',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'weightChange',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  weightChangeRegimen: {
    id: 'weight-change-regimen',
    questionRef: 'weightChangeRegimen',
    title: 'Did the change in your weight coincide with a regimen of diet and/or exercise?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
    conditional: {
      visible: {
        field: 'weightChange',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'weightChange',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  // Medical conditions checklist (questions 3.1 - 3.47)
  anginaChestPains: {
    id: 'angina-chest-pains',
    questionRef: 'anginaChestPains',
    title: 'Angina or Chest Pains',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  anginaChestPainsDetails: {
    id: 'angina-chest-pains-details',
    questionRef: 'anginaChestPainsDetails',
    title: 'Angina or Chest Pains Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'anginaChestPains',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'anginaChestPains',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  heartAttack: {
    id: 'heart-attack',
    questionRef: 'heartAttack',
    title: 'Heart Attack',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  heartAttackDetails: {
    id: 'heart-attack-details',
    questionRef: 'heartAttackDetails',
    title: 'Heart Attack Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'heartAttack',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'heartAttack',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  heartDisease: {
    id: 'heart-disease',
    questionRef: 'heartDisease',
    title: 'Heart Disease/Disorder, Coronary Artery Disease or Congestive Heart Failure',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  heartDiseaseDetails: {
    id: 'heart-disease-details',
    questionRef: 'heartDiseaseDetails',
    title: 'Heart Disease/Disorder, Coronary Artery Disease or Congestive Heart Failure Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'heartDisease',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'heartDisease',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  heartMurmur: {
    id: 'heart-murmur',
    questionRef: 'heartMurmur',
    title: 'Heart Murmur or Valvular Heart Disease',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  heartMurmurDetails: {
    id: 'heart-murmur-details',
    questionRef: 'heartMurmurDetails',
    title: 'Heart Murmur or Valvular Heart Disease Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'heartMurmur',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'heartMurmur',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  highBloodPressure: {
    id: 'high-blood-pressure',
    questionRef: 'highBloodPressure',
    title: 'High Blood Pressure',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  highBloodPressureDetails: {
    id: 'high-blood-pressure-details',
    questionRef: 'highBloodPressureDetails',
    title: 'High Blood Pressure Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'highBloodPressure',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'highBloodPressure',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  irregularHeartbeat: {
    id: 'irregular-heartbeat',
    questionRef: 'irregularHeartbeat',
    title: 'Irregular Heartbeat/Palpitations',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  irregularHeartbeatDetails: {
    id: 'irregular-heartbeat-details',
    questionRef: 'irregularHeartbeatDetails',
    title: 'Irregular Heartbeat/Palpitations Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'irregularHeartbeat',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'irregularHeartbeat',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  peripheralVascular: {
    id: 'peripheral-vascular',
    questionRef: 'peripheralVascular',
    title: 'Peripheral Vascular Disease or other Disorders of the Arteries',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  peripheralVascularDetails: {
    id: 'peripheral-vascular-details',
    questionRef: 'peripheralVascularDetails',
    title: 'Peripheral Vascular Disease or other Disorders of the Arteries Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'peripheralVascular',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'peripheralVascular',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  colitisCrohns: {
    id: 'colitis-crohns',
    questionRef: 'colitisCrohns',
    title: "Colitis or Crohn's Disease",
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  colitisCrohnsDetails: {
    id: 'colitis-crohns-details',
    questionRef: 'colitisCrohnsDetails',
    title: "Colitis or Crohn's Disease Details",
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'colitisCrohns',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'colitisCrohns',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  esophagusDisorder: {
    id: 'esophagus-disorder',
    questionRef: 'esophagusDisorder',
    title: 'Esophagus Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  esophagusDisorderDetails: {
    id: 'esophagus-disorder-details',
    questionRef: 'esophagusDisorderDetails',
    title: 'Esophagus Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'esophagusDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'esophagusDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  hepatitis: {
    id: 'hepatitis',
    questionRef: 'hepatitis',
    title: 'Hepatitis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  hepatitisDetails: {
    id: 'hepatitis-details',
    questionRef: 'hepatitisDetails',
    title: 'Hepatitis Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'hepatitis',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'hepatitis',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  intestinalDisorder: {
    id: 'intestinal-disorder',
    questionRef: 'intestinalDisorder',
    title: 'Intestinal Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  intestinalDisorderDetails: {
    id: 'intestinal-disorder-details',
    questionRef: 'intestinalDisorderDetails',
    title: 'Intestinal Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'intestinalDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'intestinalDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  liverDisorder: {
    id: 'liver-disorder',
    questionRef: 'liverDisorder',
    title: 'Liver Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  liverDisorderDetails: {
    id: 'liver-disorder-details',
    questionRef: 'liverDisorderDetails',
    title: 'Liver Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'liverDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'liverDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  pancreatitis: {
    id: 'pancreatitis',
    questionRef: 'pancreatitis',
    title: 'Pancreatitis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  pancreatitisDetails: {
    id: 'pancreatitis-details',
    questionRef: 'pancreatitisDetails',
    title: 'Pancreatitis Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'pancreatitis',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'pancreatitis',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  stomachDisorder: {
    id: 'stomach-disorder',
    questionRef: 'stomachDisorder',
    title: 'Stomach Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  stomachDisorderDetails: {
    id: 'stomach-disorder-details',
    questionRef: 'stomachDisorderDetails',
    title: 'Stomach Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'stomachDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'stomachDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  weightLossProcedure: {
    id: 'weight-loss-procedure',
    questionRef: 'weightLossProcedure',
    title: 'Weight Loss Procedure',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  weightLossProcedureDetails: {
    id: 'weight-loss-procedure-details',
    questionRef: 'weightLossProcedureDetails',
    title: 'Weight Loss Procedure Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'weightLossProcedure',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'weightLossProcedure',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  diabetes: {
    id: 'diabetes',
    questionRef: 'diabetes',
    title: 'Diabetes',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  diabetesDetails: {
    id: 'diabetes-details',
    questionRef: 'diabetesDetails',
    title: 'Diabetes Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'diabetes',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'diabetes',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  cancer: {
    id: 'cancer',
    questionRef: 'cancer',
    title: 'Cancer (excluding Basal Cell Carcinoma)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  cancerDetails: {
    id: 'cancer-details',
    questionRef: 'cancerDetails',
    title: 'Cancer (excluding Basal Cell Carcinoma) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'cancer',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'cancer',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  leukemiaLymphoma: {
    id: 'leukemia-lymphoma',
    questionRef: 'leukemiaLymphoma',
    title: 'Leukemia or Lymphoma',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  leukemiaLymphomaDetails: {
    id: 'leukemia-lymphoma-details',
    questionRef: 'leukemiaLymphomaDetails',
    title: 'Leukemia or Lymphoma Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'leukemiaLymphoma',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'leukemiaLymphoma',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  tumorMassLump: {
    id: 'tumor-mass-lump',
    questionRef: 'tumorMassLump',
    title: 'Tumor, Mass, Lump, Skin Lesions/Disorders',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  tumorMassLumpDetails: {
    id: 'tumor-mass-lump-details',
    questionRef: 'tumorMassLumpDetails',
    title: 'Tumor, Mass, Lump, Skin Lesions/Disorders Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'tumorMassLump',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'tumorMassLump',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  asthma: {
    id: 'asthma',
    questionRef: 'asthma',
    title: 'Asthma',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  asthmaDetails: {
    id: 'asthma-details',
    questionRef: 'asthmaDetails',
    title: 'Asthma Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'asthma',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'asthma',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  chronicLungDisorder: {
    id: 'chronic-lung-disorder',
    questionRef: 'chronicLungDisorder',
    title: 'Chronic Lung Disorder (COPD, Emphysema, Bronchitis)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  chronicLungDisorderDetails: {
    id: 'chronic-lung-disorder-details',
    questionRef: 'chronicLungDisorderDetails',
    title: 'Chronic Lung Disorder (COPD, Emphysema, Bronchitis) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'chronicLungDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'chronicLungDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  sleepApnea: {
    id: 'sleep-apnea',
    questionRef: 'sleepApnea',
    title: 'Sleep Apnea',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  sleepApneaDetails: {
    id: 'sleep-apnea-details',
    questionRef: 'sleepApneaDetails',
    title: 'Sleep Apnea Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'sleepApnea',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'sleepApnea',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  bloodDisorder: {
    id: 'blood-disorder',
    questionRef: 'bloodDisorder',
    title: 'Blood Disorder including Anemia or Clotting Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  bloodDisorderDetails: {
    id: 'blood-disorder-details',
    questionRef: 'bloodDisorderDetails',
    title: 'Blood Disorder including Anemia or Clotting Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'bloodDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'bloodDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  macularDegeneration: {
    id: 'macular-degeneration',
    questionRef: 'macularDegeneration',
    title: 'Macular Degeneration or Retinitis Pigmentosa',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  macularDegenerationDetails: {
    id: 'macular-degeneration-details',
    questionRef: 'macularDegenerationDetails',
    title: 'Macular Degeneration or Retinitis Pigmentosa Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'macularDegeneration',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'macularDegeneration',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  bipolarDisorder: {
    id: 'bipolar-disorder',
    questionRef: 'bipolarDisorder',
    title: 'Bipolar Disorder (Manic Depression)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  bipolarDisorderDetails: {
    id: 'bipolar-disorder-details',
    questionRef: 'bipolarDisorderDetails',
    title: 'Bipolar Disorder (Manic Depression) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'bipolarDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'bipolarDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  depression: {
    id: 'depression',
    questionRef: 'depression',
    title: 'Depression',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  depressionDetails: {
    id: 'depression-details',
    questionRef: 'depressionDetails',
    title: 'Depression Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'depression',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'depression',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  otherMentalDisorder: {
    id: 'other-mental-disorder',
    questionRef: 'otherMentalDisorder',
    title:
      'Other Mental, Emotional or Psychological disorder not listed (including Suicide Attempt)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  otherMentalDisorderDetails: {
    id: 'other-mental-disorder-details',
    questionRef: 'otherMentalDisorderDetails',
    title: 'Other Mental, Emotional or Psychological disorder not listed (including Suicide Attempt) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'otherMentalDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'otherMentalDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  bladderDisorder: {
    id: 'bladder-disorder',
    questionRef: 'bladderDisorder',
    title: 'Bladder Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  bladderDisorderDetails: {
    id: 'bladder-disorder-details',
    questionRef: 'bladderDisorderDetails',
    title: 'Bladder Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'bladderDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'bladderDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  kidneyDisorder: {
    id: 'kidney-disorder',
    questionRef: 'kidneyDisorder',
    title: 'Kidney Disorder (excluding Kidney Stones)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  kidneyDisorderDetails: {
    id: 'kidney-disorder-details',
    questionRef: 'kidneyDisorderDetails',
    title: 'Kidney Disorder (excluding Kidney Stones) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'kidneyDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'kidneyDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  prostateDisorder: {
    id: 'prostate-disorder',
    questionRef: 'prostateDisorder',
    title: 'Prostate Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  prostateDisorderDetails: {
    id: 'prostate-disorder-details',
    questionRef: 'prostateDisorderDetails',
    title: 'Prostate Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'prostateDisorder',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'prostateDisorder',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  amputation: {
    id: 'amputation',
    questionRef: 'amputation',
    title: 'Amputation',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  amputationDetails: {
    id: 'amputation-details',
    questionRef: 'amputationDetails',
    title: 'Amputation Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'amputation',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'amputation',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  arthritis: {
    id: 'arthritis',
    questionRef: 'arthritis',
    title: 'Arthritis, including Rheumatoid Arthritis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  arthritisDetails: {
    id: 'arthritis-details',
    questionRef: 'arthritisDetails',
    title: 'Arthritis, including Rheumatoid Arthritis Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'arthritis',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'arthritis',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  backSpineNeck: {
    id: 'back-spine-neck',
    questionRef: 'backSpineNeck',
    title: 'Back, Spine, or Neck Disorder',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  backSpineNeckDetails: {
    id: 'back-spine-neck-details',
    questionRef: 'backSpineNeckDetails',
    title: 'Back, Spine, or Neck Disorder Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'backSpineNeck',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'backSpineNeck',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  boneJointMuscle: {
    id: 'bone-joint-muscle',
    questionRef: 'boneJointMuscle',
    title: 'Bone, Joint or Muscle Disorder including Fibromyalgia',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  boneJointMuscleDetails: {
    id: 'bone-joint-muscle-details',
    questionRef: 'boneJointMuscleDetails',
    title: 'Bone, Joint or Muscle Disorder including Fibromyalgia Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'boneJointMuscle',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'boneJointMuscle',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  osteoporosis: {
    id: 'osteoporosis',
    questionRef: 'osteoporosis',
    title: 'Osteoporosis/Osteopenia or Compression Fracture',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  osteoporosisDetails: {
    id: 'osteoporosis-details',
    questionRef: 'osteoporosisDetails',
    title: 'Osteoporosis/Osteopenia or Compression Fracture Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'osteoporosis',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'osteoporosis',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  memoryLoss: {
    id: 'memory-loss',
    questionRef: 'memoryLoss',
    title: 'Memory Loss or Forgetfulness',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  memoryLossDetails: {
    id: 'memory-loss-details',
    questionRef: 'memoryLossDetails',
    title: 'Memory Loss or Forgetfulness Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'memoryLoss',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'memoryLoss',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  brainNervousSystem: {
    id: 'brain-nervous-system',
    questionRef: 'brainNervousSystem',
    title: 'Brain or Nervous System Disorder including Head Injury',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  brainNervousSystemDetails: {
    id: 'brain-nervous-system-details',
    questionRef: 'brainNervousSystemDetails',
    title: 'Brain or Nervous System Disorder including Head Injury Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'brainNervousSystem',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'brainNervousSystem',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  injuryFalls: {
    id: 'injury-falls',
    questionRef: 'injuryFalls',
    title: 'Injury due to Falls or Imbalance',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  injuryFallsDetails: {
    id: 'injury-falls-details',
    questionRef: 'injuryFallsDetails',
    title: 'Injury due to Falls or Imbalance Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'injuryFalls',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'injuryFalls',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  paralysis: {
    id: 'paralysis',
    questionRef: 'paralysis',
    title: 'Paralysis',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  paralysisDetails: {
    id: 'paralysis-details',
    questionRef: 'paralysisDetails',
    title: 'Paralysis Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'paralysis',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'paralysis',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  tremors: {
    id: 'tremors',
    questionRef: 'tremors',
    title: 'Tremor(s)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  tremorsDetails: {
    id: 'tremors-details',
    questionRef: 'tremorsDetails',
    title: 'Tremor(s) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'tremors',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'tremors',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  postPolioSyndrome: {
    id: 'post-polio-syndrome',
    questionRef: 'postPolioSyndrome',
    title: 'Post-Polio Syndrome',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  postPolioSyndromeDetails: {
    id: 'post-polio-syndrome-details',
    questionRef: 'postPolioSyndromeDetails',
    title: 'Post-Polio Syndrome Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'postPolioSyndrome',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'postPolioSyndrome',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  seizuresConvulsions: {
    id: 'seizures-convulsions',
    questionRef: 'seizuresConvulsions',
    title: 'Seizures, Convulsions or Fainting',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  seizuresConvulsionsDetails: {
    id: 'seizures-convulsions-details',
    questionRef: 'seizuresConvulsionsDetails',
    title: 'Seizures, Convulsions or Fainting Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'seizuresConvulsions',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'seizuresConvulsions',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  strokeTia: {
    id: 'stroke-tia',
    questionRef: 'strokeTia',
    title: 'Stroke/Mini-stroke (Transient Ischemic Attack - TIA)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  strokeTiaDetails: {
    id: 'stroke-tia-details',
    questionRef: 'strokeTiaDetails',
    title: 'Stroke/Mini-stroke (Transient Ischemic Attack - TIA) Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'strokeTia',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'strokeTia',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  hivAids: {
    id: 'hiv-aids',
    questionRef: 'hivAids',
    title: 'Human Immunodeficiency Virus (HIV) Infection/AIDS',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  hivAidsDetails: {
    id: 'hiv-aids-details',
    questionRef: 'hivAidsDetails',
    title: 'Human Immunodeficiency Virus (HIV) Infection/AIDS Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'hivAids',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'hivAids',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  lupusScleroderma: {
    id: 'lupus-scleroderma',
    questionRef: 'lupusScleroderma',
    title: 'Lupus (SLE), Scleroderma or CREST Syndrome',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  lupusSclerodermaDetails: {
    id: 'lupus-scleroderma-details',
    questionRef: 'lupusSclerodermaDetails',
    title: 'Lupus (SLE), Scleroderma or CREST Syndrome Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'lupusScleroderma',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'lupusScleroderma',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  organTransplant: {
    id: 'organ-transplant',
    questionRef: 'organTransplant',
    title: 'Organ Transplant',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  organTransplantDetails: {
    id: 'organ-transplant-details',
    questionRef: 'organTransplantDetails',
    title: 'Organ Transplant Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'organTransplant',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'organTransplant',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  otherCripplingConditions: {
    id: 'other-crippling-conditions',
    questionRef: 'otherCripplingConditions',
    title: 'Other conditions causing Crippling, Limited Motion or Requiring Adaptive Devices',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  otherCripplingConditionsDetails: {
    id: 'other-crippling-conditions-details',
    questionRef: 'otherCripplingConditionsDetails',
    title: 'Other conditions causing Crippling, Limited Motion or Requiring Adaptive Devices Details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'otherCripplingConditions',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'otherCripplingConditions',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  advisedByMedicalProfession: {
    id: 'advised-by-medical-profession',
    questionRef: 'advisedByMedicalProfession',
    title:
      'Have you been advised by a member of the medical profession to have a diagnostic test, surgery, procedure, or hospitalization within the next 6 months?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  advisedByMedicalProfessionDetails: {
    id: 'advised-by-medical-profession-details',
    questionRef: 'advisedByMedicalProfessionDetails',
    title: 'Advised by a member of the medical profession to have a diagnostic test, surgery, procedure, or hospitalization within the next 6 months details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'advisedByMedicalProfession',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'advisedByMedicalProfession',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  additionalPrescriptionMedications: {
    id: 'additional-prescription-medications',
    questionRef: 'additionalPrescriptionMedications',
    title:
      'Other than previously answered, are you taking any additional prescription medications?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicationDetails: {
    id: 'medication-details',
    questionRef: 'medicationDetails',
    title: 'If YES, provide medication name and reason prescribed',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'additionalPrescriptionMedications',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'additionalPrescriptionMedications',
        operator: 'equals',
        value: 'yes',
      },
    },
    characterLimit: {
      limit: 100,
      mode: 'overflow'
    }
  },

  hospitalPatient: {
    id: 'hospital-patient',
    questionRef: 'hospitalPatient',
    title:
      'Have you within the past 5 years been a patient in a hospital, emergency room, or medical facility?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  hospitalPatientDetails: {
    id: 'hospital-patient-details',
    questionRef: 'hospitalPatientDetails',
    title:
      'Within past 5 years been a patient in a hospital, emergency room, or medical facility details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'hospitalPatient',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'hospitalPatient',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  otherTreatment: {
    id: 'other-treatment',
    questionRef: 'otherTreatment',
    title:
      'Have you within the past 5 years been treated by a professional health care provider for a condition or illness not listed above?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  otherTreatmentDetails: {
    id: 'other-treatment-details',
    questionRef: 'otherTreatmentDetails',
    title:
      'Within past 5 years been treated by a professional health care provider for a condition or illness not listed above details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'otherTreatment',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'otherTreatment',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  incompleteTests: {
    id: 'incomplete-tests',
    questionRef: 'incompleteTests',
    title:
      'Have you within the past 5 years been advised to have any diagnostic test, hospitalization, treatment or surgery which was not completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  incompleteTestsDetails: {
    id: 'incomplete-tests-details',
    questionRef: 'incompleteTestsDetails',
    title:
      'Within past 5 years been advised to have any diagnostic test, hospitalization, treatment or surgery which was not completed details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'incompleteTests',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'incompleteTests',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  assistanceRequired: {
    id: 'assistance-required',
    questionRef: 'assistanceRequired',
    title:
      'Have you within the past 5 years required assistance with managing medications, shopping, transportation or housekeeping/cooking?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  assistanceRequiredDetails: {
    id: 'assistance-required-details',
    questionRef: 'assistanceRequiredDetails',
    title:
      'Within past 5 years required assistance with managing medications, shopping, transportation or housekeeping/cooking details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'assistanceRequired',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'assistanceRequired',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  receivedHomeCare: {
    id: 'received-home-care',
    questionRef: 'receivedHomeCare',
    title:
      'Have you within the past 5 years received home health care; used an adult day care facility; been confined to a nursing home, assisted care facility or other long-term care facility?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  receivedHomeCareDetails: {
    id: 'received-home-care-details',
    questionRef: 'receivedHomeCareDetails',
    title:
      'Within past 5 years received home health care; used an adult day care facility; been confined to a nursing home, assisted care facility or other long-term care facility details',
    titleOverride: MEDICAL_DETAILS_TITLE_OVERRIDE,
    type: 'textarea-text',
    required: false,
    overflow: true,
    conditional: {
      visible: {
        field: 'receivedHomeCare',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'receivedHomeCare',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  disabilityBenefits: {
    id: 'disability-benefits',
    questionRef: 'disabilityBenefits',
    title: 'Have you requested or received in the last 5 years:',
    type: 'radio',
    options: [
      { id: 'workers-comp', value: "Worker's Compensation" },
      { id: 'other-disability', value: 'Other Disability Income' },
    ],
  },
  disabilityDescription: {
    id: 'disability-description',
    questionRef: 'disabilityDescription',
    title: 'Brief Description of Disability',
    type: 'textarea',
    conditional: {
      visible: {
        field: 'disabilityBenefits',
        operator: 'notEmpty',
      },
      required: {
        field: 'disabilityBenefits',
        operator: 'notEmpty',
      },
    },
  },
  disabilityFromDate: {
    id: 'disability-from-date',
    questionRef: 'disabilityFromDate',
    title: 'From Date (mm/dd/yyyy)',
    type: 'date',
    conditional: {
      visible: {
        field: 'disabilityBenefits',
        operator: 'notEmpty',
      },
      required: {
        field: 'disabilityBenefits',
        operator: 'notEmpty',
      },
    },
  },
  disabilityToDate: {
    id: 'disability-to-date',
    questionRef: 'disabilityToDate',
    title: 'To Date (mm/dd/yyyy)',
    type: 'date',
    conditional: {
      visible: {
        field: 'disabilityBenefits',
        operator: 'notEmpty',
      },
      required: {
        field: 'disabilityBenefits',
        operator: 'notEmpty',
      },
    },
  },

  /* Section D - Social History */
  tobaccoUse: {
    id: 'tobacco-use',
    questionRef: 'tobaccoUse',
    title:
      'Have you ever used tobacco or any other product that contains nicotine, such as cigarettes, e-cigarettes, occasional cigarette, cigars, celebratory cigar, chewing tobacco, pipe, electronic vapor device, nicotine patch or nicotine gum?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  tobaccoType: {
    id: 'tobacco-type',
    questionRef: 'tobaccoType',
    title: 'Type of Product',
    type: 'text',
    conditional: {
      visible: {
        field: 'tobaccoUse',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'tobaccoUse',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  tobaccoFrequency: {
    id: 'tobacco-frequency',
    questionRef: 'tobaccoFrequency',
    title: 'Frequency',
    type: 'text',
    conditional: {
      visible: {
        field: 'tobaccoUse',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'tobaccoUse',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  tobaccoDateLastUsed: {
    id: 'tobacco-date-last-used',
    questionRef: 'tobaccoDateLastUsed',
    title: 'Date Last Used (mm/dd/yyyy)',
    type: 'date',
    conditional: {
      visible: {
        field: 'tobaccoUse',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'tobaccoUse',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  drinkAlcohol: {
    id: 'drink-alcohol',
    questionRef: 'drinkAlcohol',
    title: 'Do you drink alcohol?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  alcoholEverUsed: {
    id: 'alcohol-ever-used',
    questionRef: 'alcoholEverUsed',
    title: 'If NO, have you ever used alcohol in any form?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
    conditional: {
      visible: {
        field: 'drinkAlcohol',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'drinkAlcohol',
        operator: 'equals',
        value: 'no',
      },
    },
  },
  alcoholDateLastUsed: {
    id: 'alcohol-date-last-used',
    questionRef: 'alcoholDateLastUsed',
    title: 'Date of last use?',
    type: 'date',
    conditional: {
      visible: {
        field: 'alcoholEverUsed',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'alcoholEverUsed',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  alcoholReasonQuit: {
    id: 'alcohol-reason-quit',
    questionRef: 'alcoholReasonQuit',
    title: 'Reason for quitting?',
    type: 'text',
    conditional: {
      visible: {
        field: 'alcoholEverUsed',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'alcoholEverUsed',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  alcoholType: {
    id: 'alcohol-type',
    questionRef: 'alcoholType',
    title: 'What type?',
    type: 'text',
    conditional: {
      visible: {
        field: 'drinkAlcohol',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'drinkAlcohol',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  alcoholFrequencyAmount: {
    id: 'alcohol-frequency-amount',
    questionRef: 'alcoholFrequencyAmount',
    title: 'Frequency and Amount',
    type: 'text',
    conditional: {
      visible: {
        field: 'drinkAlcohol',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'drinkAlcohol',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  alcoholAdvised: {
    id: 'alcohol-advised',
    questionRef: 'alcoholAdvised',
    title:
      'Have you ever been advised by a member of the medical profession to reduce or quit alcohol use?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  alcoholAdvisedDetails: {
    id: 'alcohol-advised-details',
    questionRef: 'alcoholAdvisedDetails',
    title: 'Details',
    type: 'text',
    conditional: {
      visible: {
        field: 'alcoholAdvised',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'alcoholAdvised',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  alcoholCounseling: {
    id: 'alcohol-counseling',
    questionRef: 'alcoholCounseling',
    title:
      'Have you received or been advised by a member of the medical profession to receive Alcohol Counseling Treatment?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  alcoholCounselingDetails: {
    id: 'alcohol-counseling-details',
    questionRef: 'alcoholCounselingDetails',
    title: 'Details',
    type: 'text',
    conditional: {
      visible: {
        field: 'alcoholCounseling',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'alcoholCounseling',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  drugUse: {
    id: 'drug-use',
    questionRef: 'drugUse',
    title:
      'Other than as prescribed by a physician, have you ever used marijuana, narcotics, stimulants, sedatives, hallucinogens, or any prescription drugs?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  drugSubstanceName: {
    id: 'drug-substance-name',
    questionRef: 'drugSubstanceName',
    title: 'Name of Substance',
    type: 'text',
    conditional: {
      visible: {
        field: 'drugUse',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'drugUse',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  drugDateLastUsed: {
    id: 'drug-date-last-used',
    questionRef: 'drugDateLastUsed',
    title: 'Date Last Used',
    type: 'date',
    conditional: {
      visible: {
        field: 'drugUse',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'drugUse',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  drugFrequency: {
    id: 'drug-frequency',
    questionRef: 'drugFrequency',
    title: 'Frequency',
    type: 'select',
    options: [
      { id: 'occasionally', value: 'Occasionally' },
      { id: 'daily', value: 'Daily' },
      { id: 'weekly', value: 'Weekly' },
      { id: 'monthly', value: 'Monthly' },
    ],
    conditional: {
      visible: {
        field: 'drugUse',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'drugUse',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  drugAlcoholTreatment: {
    id: 'drug-alcohol-treatment',
    questionRef: 'drugAlcoholTreatment',
    title:
      'Within the last 5 years, have you received medical advice, been diagnosed, examined or treated by a member of the medical profession for alcoholism or drug use?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  drugAlcoholTreatmentDetails: {
    id: 'drug-alcohol-treatment-details',
    questionRef: 'drugAlcoholTreatmentDetails',
    title: 'Details',
    type: 'text',
    conditional: {
      visible: {
        field: 'drugAlcoholTreatment',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'drugAlcoholTreatment',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  currentlyEmployed: {
    id: 'currently-employed',
    questionRef: 'currentlyEmployed',
    title: 'Are you currently employed full time or part time?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  occupation: {
    id: 'occupation',
    questionRef: 'occupation',
    title: 'Occupation',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'currentlyEmployed',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'currentlyEmployed',
        operator: 'equals',
        value: 'yes',
      },
    },
    characterLimit: {
      limit: 50,
      mode: 'overflow'
    }
  },
  hobbiesActivities: {
    id: 'hobbies-activities',
    questionRef: 'hobbiesActivities',
    title:
      'Do you have any hobbies, interests or participate in any activities outside of your home, including volunteer work?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  activityTypes: {
    id: 'activity-types',
    questionRef: 'activityTypes',
    title: 'Type of activity(ies)',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'hobbiesActivities',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'hobbiesActivities',
        operator: 'equals',
        value: 'yes',
      },
    },
    characterLimit: {
      limit: 75,
      mode: 'overflow'
    }
  },
  activityTypesSecond: {
    id: 'activity-types-second',
    questionRef: 'activityTypesSecond',
    title: 'Type of activity(ies)',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'hobbiesActivities',
        operator: 'equals',
        value: 'yes',
      },
    },
    characterLimit: {
      limit: 75,
      mode: 'overflow'
    }
  },
  activityHoursPerWeek: {
    id: 'activity-hours-per-week',
    questionRef: 'activityHoursPerWeek',
    title: 'Hours per week',
    type: 'number',
    required: false,
    conditional: {
      visible: {
        field: 'hobbiesActivities',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'hobbiesActivities',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  activityHoursPerWeekSecond: {
    id: 'activity-hours-per-week-second',
    questionRef: 'activityHoursPerWeekSecond',
    title: 'Hours per week',
    type: 'number',
    required: false,
    conditional: {
      visible: {
        field: 'hobbiesActivities',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  driveAutomobile: {
    id: 'drive-automobile',
    questionRef: 'driveAutomobile',
    title: 'Do you drive an automobile?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  annualMileage: {
    id: 'annual-mileage',
    questionRef: 'annualMileage',
    title: 'Mileage',
    type: 'number',
    required: false,
    conditional: {
      visible: {
        field: 'driveAutomobile',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'driveAutomobile',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  retirementCommunity: {
    id: 'retirement-community',
    questionRef: 'retirementCommunity',
    title: 'Do you live in some form of a retirement community?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  retirementServices: {
    id: 'retirement-services',
    questionRef: 'retirementServices',
    title: 'Services',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'retirementCommunity',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'retirementCommunity',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  /* Section E - Family History */
  fatherLiving: {
    id: 'father-living',
    questionRef: 'fatherLiving',
    title: 'Is your biological father living?',
    type: 'select',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },
  fatherAge: {
    id: 'father-age',
    questionRef: 'fatherAge',
    title: 'Age if living',
    type: 'number',
    conditional: {
      visible: {
        field: 'fatherLiving',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'fatherLiving',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  fatherAgeAtDeath: {
    id: 'father-age-at-death',
    questionRef: 'fatherAgeAtDeath',
    title: 'Age at death',
    type: 'number',
    conditional: {
      visible: {
        field: 'fatherLiving',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'fatherLiving',
        operator: 'equals',
        value: 'no',
      },
    },
  },
  fatherAlzheimers: {
    id: 'father-alzheimers',
    questionRef: 'fatherAlzheimers',
    title: "Alzheimer's Disease or any other form of dementia?",
    type: 'select',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },
  fatherHuntingtons: {
    id: 'father-huntingtons',
    questionRef: 'fatherHuntingtons',
    title: "Huntington's Disease?",
    type: 'select',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },
  motherLiving: {
    id: 'mother-living',
    questionRef: 'motherLiving',
    title: 'Is your biological mother living?',
    type: 'select',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },
  motherAge: {
    id: 'mother-age',
    questionRef: 'motherAge',
    title: 'Age if living',
    type: 'number',
    conditional: {
      visible: {
        field: 'motherLiving',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'motherLiving',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  motherAgeAtDeath: {
    id: 'mother-age-at-death',
    questionRef: 'motherAgeAtDeath',
    title: 'Age at death',
    type: 'number',
    conditional: {
      visible: {
        field: 'motherLiving',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'motherLiving',
        operator: 'equals',
        value: 'no',
      },
    },
  },
  motherAlzheimers: {
    id: 'mother-alzheimers',
    questionRef: 'motherAlzheimers',
    title: "Alzheimer's Disease or any other form of dementia?",
    type: 'select',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },
  motherHuntingtons: {
    id: 'mother-huntingtons',
    questionRef: 'motherHuntingtons',
    title: "Huntington's Disease?",
    type: 'select',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'unknown', value: 'Unknown' },
    ],
  },

  // ========DEPRACATED FOR NOW==========
  /* Section F - Details  */
  // detailsForYesResponses: {
  //   id: 'details-for-yes-responses',
  //   questionRef: 'detailsForYesResponses',
  //   title:
  //     'For each Yes response, provide the condition diagnosed, date of diagnosis, test results, any treatments or medications, name and address of provider/facility and date last seen.',
  //   type: 'textarea',
  //   required: false,
  //   conditional: {
  //     visible: {
  //       operator: 'or',
  //       conditions: [
  //         {
  //           field: 'fatherAlzheimers',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //         {
  //           field: 'fatherHuntingtons',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //         {
  //           field: 'motherAlzheimers',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //         {
  //           field: 'motherHuntingtons',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //       ],
  //     },
  //     required: {
  //       operator: 'or',
  //       conditions: [
  //         {
  //           field: 'fatherAlzheimers',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //         {
  //           field: 'fatherHuntingtons',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //         {
  //           field: 'motherAlzheimers',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //         {
  //           field: 'motherHuntingtons',
  //           value: 'yes',
  //           operator: 'equals',
  //         },
  //       ],
  //     },
  //   },
  // },

  /* Section G - Other Coverage and Replacement */
  currentlyEnrolledMedicaid: {
    id: 'currently-enrolled-medicaid',
    questionRef: 'currentlyEnrolledMedicaid',
    title: 'Are you currently enrolled in Medicaid (not the same as Medicare)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  existingLtcInsurance: {
    id: 'existing-ltc-insurance',
    questionRef: 'existingLtcInsurance',
    title:
      'Do you have any Accident and Sickness, Long-Term Care, Nursing Home, or Home Health Care insurance policy/certificate in force or applied for? (Including any health care service contract, health maintenance organization contract or life insurance with Long-Term Care coverage.)',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  existingLtcCompany: {
    id: 'existing-ltc-company',
    questionRef: 'existingLtcCompany',
    title: 'Company',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'existingLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'existingLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  existingLtcCoverage: {
    id: 'existing-ltc-coverage',
    questionRef: 'existingLtcCoverage',
    title: 'Long-Term Care?',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
    conditional: {
      visible: {
        field: 'existingLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'existingLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  existingDailyBenefit: {
    id: 'existing-daily-benefit',
    questionRef: 'existingDailyBenefit',
    title: 'Daily Benefit',
    type: 'text',
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'existingLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        operator: 'and',
        conditions: [
          {
            field: 'existingLtcInsurance',
            operator: 'equals',
            value: 'yes',
          },
          {
            field: 'existingMonthlyBenefit',
            operator: 'empty',
          },
        ],
      },
    },
  },
  existingMonthlyBenefit: {
    id: 'existing-monthly-benefit',
    questionRef: 'existingMonthlyBenefit',
    title: 'Monthly Benefit',
    type: 'text',
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'existingLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        operator: 'and',
        conditions: [
          {
            field: 'existingLtcInsurance',
            operator: 'equals',
            value: 'yes',
          },
          {
            field: 'existingDailyBenefit',
            operator: 'empty',
          },
        ],
      },
    },
  },
  previousLtcInsurance: {
    id: 'previous-ltc-insurance',
    questionRef: 'previousLtcInsurance',
    title:
      'Did you have another Long-Term Care, Nursing Home, or Home Health Care insurance policy/certificate in force during the last 12 months?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  previousLtcCompany: {
    id: 'previous-ltc-company',
    questionRef: 'previousLtcCompany',
    title: 'Company',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'previousLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  previousLtcLapseDate: {
    id: 'previous-ltc-lapse-date',
    questionRef: 'previousLtcLapseDate',
    title: 'Lapse Date',
    type: 'date',
    conditional: {
      visible: {
        field: 'previousLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousLtcInsurance',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  intendToReplace: {
    id: 'intend-to-replace',
    questionRef: 'intendToReplace',
    title:
      'Do you intend to replace any of your Long-Term Care, medical or health insurance coverage with this policy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  replaceLtcCoverage: {
    id: 'replace-ltc-coverage',
    questionRef: 'replaceLtcCoverage',
    title: 'Long-Term Care?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
    conditional: {
      visible: {
        field: 'intendToReplace',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'intendToReplace',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  replaceCompany: {
    id: 'replace-company',
    questionRef: 'replaceCompany',
    title: 'Company',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'intendToReplace',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'intendToReplace',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  replacePolicyNumber: {
    id: 'replace-policy-number',
    questionRef: 'replacePolicyNumber',
    title: 'Policy/Certificate #',
    type: 'text',
    conditional: {
      visible: {
        field: 'intendToReplace',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'intendToReplace',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  previousApplicationDeclined: {
    id: 'previous-application-declined',
    questionRef: 'previousApplicationDeclined',
    title:
      'Within the past 2 years, have you had another application or reinstatement request for long-term care or life insurance declined, postponed, or have you been rated substandard by any other company?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  declinedCompany: {
    id: 'declined-company',
    questionRef: 'declinedCompany',
    title: 'Company',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  declinedProduct: {
    id: 'declined-product',
    questionRef: 'declinedProduct',
    title: 'Product',
    type: 'text',
    conditional: {
      visible: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  declinedAction: {
    id: 'declined-action',
    questionRef: 'declinedAction',
    title: 'Action',
    type: 'radio',
    required: false,
    options: [
      { id: 'declined', value: 'Declined' },
      { id: 'postponed', value: 'Postponed' },
      { id: 'rated', value: 'Rated' },
    ],
    conditional: {
      visible: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  declinedReason: {
    id: 'declined-reason',
    questionRef: 'declinedReason',
    title: 'Reason',
    type: 'text',
    conditional: {
      visible: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  declinedDateOfAction: {
    id: 'declined-date-of-action',
    questionRef: 'declinedDateOfAction',
    title: 'Date of Action',
    type: 'date',
    conditional: {
      visible: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'previousApplicationDeclined',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  /* Section H - Protection Against Unintentional Lapse */
  protectionAgainstUnintentionalLapse: {
    id: 'protection-against-unintentional-lapse',
    questionRef: 'protectionAgainstUnintentionalLapse',
    title:
      'I understand that I have the right to designate at least one person other than myself to receive notice of lapse or termination of this long-term care insurance policy for non-payment of premium. I understand that notice will not be given until 30 days after a premium is due and unpaid.',
    type: 'radio',
    format: 'vertical',
    required: true,
    options: [
      { id: 'no', value: 'I elect NOT to designate any person to receive such notice.' },
      {
        id: 'yes',
        value:
          'I designate the following person to receive notice prior to cancellation of my policy for non-payment of premium',
      },
    ],
  },

  protectionAgainstUnintentionalLapseName: {
    id: 'protection-against-unintentional-lapse-name',
    questionRef: 'protectionAgainstUnintentionalLapseName',
    title: 'Name: ',
    type: 'text',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  protectionAgainstUnintentionalLapseStreetAddress: {
    id: 'protection-against-unintentional-lapse-street-address',
    questionRef: 'protectionAgainstUnintentionalLapseStreetAddress',
    title: 'Address: ',
    type: 'text',
    validationType: 'streetAddress',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  protectionAgainstUnintentionalLapseCity: {
    id: 'protection-against-unintentional-lapse-city',
    questionRef: 'protectionAgainstUnintentionalLapseCity',
    title: 'City: ',
    type: 'text',
    validationType: 'city',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  protectionAgainstUnintentionalLapseState: {
    id: 'protection-against-unintentional-lapse-state',
    questionRef: 'protectionAgainstUnintentionalLapseState',
    title: 'State: ',
    type: 'text',
    validationType: 'state',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  protectionAgainstUnintentionalLapseZipCode: {
    id: 'protection-against-unintentional-lapse-zip-code',
    questionRef: 'protectionAgainstUnintentionalLapseZipCode',
    title: 'Zip Code: ',
    type: 'text',
    validationType: 'zipcode',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  protectionAgainstUnintentionalLapsePhoneNumber: {
    id: 'protection-against-unintentional-lapse-phone-number',
    questionRef: 'protectionAgainstUnintentionalLapsePhoneNumber',
    title: 'Phone Number: ',
    type: 'text',
    validationType: 'phone',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  protectionAgainstUnintentionalLapseRelationship: {
    id: 'protection-against-unintentional-lapse-relationship',
    questionRef: 'protectionAgainstUnintentionalLapseRelationship',
    title: 'Relationship: ',
    type: 'text',
    conditional: {
      visible: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
      required: {
        field: 'protectionAgainstUnintentionalLapse',
        value: 'yes',
        operator: 'contains',
      },
    },
  },

  /* Section J - Producer Signature */
  producerPoliciesSoldToApplicant: {
    id: 'producer-policies-sold-to-applicant',
    questionRef: 'producerPoliciesSoldToApplicant',
    title: 'List other health insurance policies sold by you to the Applicant',
    type: 'table',
    minRows: 0,
    maxRows: 2,
    gridColumns: 1,
    columns: [
      {
        id: 'policyName',
        title: 'Policy Name',
        type: 'text',
      },
    ],
  },

  producerPoliciesSoldToApplicant5Years: {
    id: 'producer-policies-sold-to-applicant-5-years',
    questionRef: 'producerPoliciesSoldToApplicant5Years',
    title:
      'List health insurance policies sold by you to the Applicant in the past 5 years that are no longer in force',
    type: 'table',
    minRows: 0,
    maxRows: 4,
    gridColumns: 1,
    columns: [
      {
        id: 'policyName',
        title: 'Policy Name',
        type: 'text',
      },
    ],
  },

  // Page 14 (Long-Term Care Insurance Application Overflow Form)
  applicationOverflowRemarksAutoCollected: {
    id: 'application-overflow-remarks-auto-collected',
    questionRef: 'applicationOverflowRemarksAutoCollected',
    title: 'Medical Condition Details (Auto-collected from all "Yes" answers above)',
    type: 'textarea-append',
    disabled: true,
    hidden: true,
  },
  applicationOverflowRemarks: {
    id: 'application-overflow-remarks',
    questionRef: 'applicationOverflowRemarks',
    title:
      'Remarks (condition, date of diagnosis, test results, treatments/medications, provider/facility name & address, date last seen)',
    type: 'textarea',
    placeholder: 'Provide details…',
  },

  // Page 15 (Health Insurance Authorization)
  last4DigitsOfSSN: {
    id: 'last-4-digits-of-ssn',
    questionRef: 'last4DigitsOfSSN',
    title: 'Last 4 Digits of SSN',
    type: 'text',
    required: true,
    validationType: 'ssn4Digit',
  },

  // Page 16 (Long-Term Care Insurance Personal Worksheet)
  personalWorksheetPremiumMonthly: {
    id: 'personal-worksheet-premium-monthly',
    questionRef: 'personalWorksheetPremiumMonthly',
    title: 'Monthly Premium Amount ($)',
    type: 'text',
    validationType: 'currency',
  },

  personalWorksheetPremiumQuarterly: {
    id: 'personal-worksheet-premium-quarterly',
    questionRef: 'personalWorksheetPremiumQuarterly',
    title: 'Quarterly Premium Amount ($)',
    type: 'text',
    validationType: 'currency',
  },

  personalWorksheetPremiumSemiAnnually: {
    id: 'personal-worksheet-premium-semi-annually',
    questionRef: 'personalWorksheetPremiumSemiAnnually',
    title: 'Semi-Annual Premium Amount ($)',
    type: 'text',
    validationType: 'currency',
  },

  personalWorksheetPremiumTotal: {
    id: 'personal-worksheet-premium-total',
    questionRef: 'personalWorksheetPremiumTotal',
    title: 'Total Annual Premium ($)',
    type: 'text',
    validationType: 'currency',
  },

  // Only used for Waterlily Application Flow
  personalWorksheetPreDisclosure: {
    id: 'personal-worksheet-pre-disclosure',
    questionRef: 'personalWorksheetPreDisclosure',
    title:
      'Financial information is a key aspect of helping you and the company decide if you should buy this policy. Long-term care insurance can be expensive and it may not be right for everyone. Are you comfortable with disclosing financial details to fill out the Long-Term Care Insurance Personal Worksheet?',
    type: 'radio',
    required: true,
    options: [
      {
        id: 'yes',
        value: 'Yes',
      },
      {
        id: 'no',
        value:
          'No',
      },
    ],
  },

  personalWorksheetPayResources: {
    id: 'personal-worksheet-pay-resources',
    questionRef: 'personalWorksheetPayResources',
    title: 'What resources will you use to pay your premium?',
    type: 'multiselect',
    format: 'vertical',
    options: [
      { id: 'current-employment-income', value: 'Current income from employment' },
      { id: 'current-investment-income', value: 'Current income from investments' },
      { id: 'current-income', value: 'Other current income' },
      { id: 'savings', value: 'Savings' },
      { id: 'sell-investments', value: 'Sell investments' },
      { id: 'sell-assets', value: 'Sell other assets' },
      { id: 'family-money', value: 'Money from my family' },
      { id: 'other', value: 'Other' },
    ],
  },

  personalWorksheetPayResourcesOther: {
    id: 'personal-worksheet-pay-resources-other',
    questionRef: 'personalWorksheetPayResourcesOther',
    title: 'Other Resources',
    type: 'text',
    conditional: {
      visible: {
        field: 'personalWorksheetPayResources',
        operator: 'contains',
        value: 'other',
      },
    },
  },

  personalWorksheetSourceOfFunds: {
    id: 'personal-worksheet-source-of-funds',
    questionRef: 'personalWorksheetSourceOfFunds',
    title: 'Is the source of these funds from:',
    type: 'multiselect',
    options: [
      { id: '401k', value: '401(k), Pension or other Qualified Plan' },
      { id: 'ira', value: 'IRA/Roth IRA' },
    ],
  },

  personalWorksheetAffordPolicyIfSpouseDies: {
    id: 'personal-worksheet-afford-policy-if-spouse-dies',
    questionRef: 'personalWorksheetAffordPolicyIfSpouseDies',
    title: 'Could you afford to keep this policy if your spouse or partner dies first?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'hadnt-thought-about-it', value: "Hadn't thought about it" },
      { id: 'dont-know', value: "Don't know" },
      { id: 'doesnt-apply', value: "Doesn't apply" },
    ],
  },

  personalWorksheetPremiumIncreaseResponse: {
    id: 'personal-worksheet-premium-increase-response',
    questionRef: 'personalWorksheetPremiumIncreaseResponse',
    title: 'What would you do if the premiums went up, for example, by fifty percent (50%)?',
    type: 'multiselect',
    options: [
      { id: 'pay-higher-premium', value: 'Pay the higher premium' },
      { id: 'reduce-benefits', value: 'Reduce benefits' },
      { id: 'call-agent', value: 'Call the company/agent' },
      { id: 'drop-policy', value: 'Drop the policy' },
      { id: 'dont-know', value: "Don't know" },
    ],
  },

  personalWorksheetHouseholdIncome: {
    id: 'personal-worksheet-household-income',
    questionRef: 'personalWorksheetHouseholdIncome',
    title: 'What is your household annual income from all sources? (check one)',
    type: 'radio',
    options: [
      { id: 'under-30000', value: 'Under $30,000' },
      { id: '30000-50000', value: '$30,000 - $50,000' },
      { id: 'over-50000', value: 'Over $50,000' },
    ],
  },

  personalWorksheetIncomeChange: {
    id: 'personal-worksheet-income-change',
    questionRef: 'personalWorksheetIncomeChange',
    title: 'Do you expect your income to change in the next ten (10) years? (check one)',
    type: 'radio',
    options: [
      { id: 'no', value: 'No' },
      { id: 'increase', value: 'Yes, expect increase' },
      { id: 'decrease', value: 'Yes, expect decrease' },
    ],
  },

  personalWorksheetIncomeAbilityImpact: {
    id: 'personal-worksheet-income-ability-impact',
    questionRef: 'personalWorksheetIncomeAbilityImpact',
    title:
      'If you plan to pay premiums from your income, have you thought about how a change in your income would affect your ability to continue to pay the premium?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
      { id: 'dont-know', value: "Don't know" },
    ],
  },

  personalWorksheetBuyInflationProtection: {
    id: 'personal-worksheet-buy-inflation-protection',
    questionRef: 'personalWorksheetBuyInflationProtection',
    title: 'Will you buy inflation protection?',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  personalWorksheetFutureCostCoverage: {
    id: 'personal-worksheet-future-cost-coverage',
    questionRef: 'personalWorksheetFutureCostCoverage',
    title:
      "If you don't buy inflation protection, how will you pay for the difference between future costs and your daily benefit amount?",
    type: 'multiselect',
    format: 'vertical',
    options: [
      { id: 'income', value: 'From my income' },
      { id: 'savings', value: 'From savings' },
      { id: 'investments', value: 'From investments' },
      { id: 'sell-assets', value: 'Sell other assets' },
      { id: 'family-money', value: 'Money from my family' },
      { id: 'other', value: 'Other' },
    ],
    conditional: {
      visible: {
        field: 'personalWorksheetBuyInflationProtection',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'personalWorksheetBuyInflationProtection',
        operator: 'equals',
        value: 'no',
      },
    },
  },

  personalWorksheetFutureCostCoverageOther: {
    id: 'personal-worksheet-future-cost-coverage-other',
    questionRef: 'personalWorksheetFutureCostCoverageOther',
    title: 'Other Resources',
    type: 'text',
    conditional: {
      visible: {
        field: 'personalWorksheetFutureCostCoverage',
        operator: 'contains',
        value: 'other',
      },
    },
  },

  personalWorksheetDeductiblePeriod: {
    id: 'personal-worksheet-deductible-period',
    questionRef: 'personalWorksheetDeductiblePeriod',
    title: 'What Deductible Period are you considering?',
    type: 'radio',
    options: [
      { id: '90-days', value: '90 Days ($31,500)' },
      { id: '180-days', value: '180 Days ($63,000)' },
    ],
  },

  personalWorksheetDeductiblePeriodPayment: {
    id: 'personal-worksheet-deductible-period-payment',
    questionRef: 'personalWorksheetDeductiblePeriodPayment',
    title:
      'How do you plan to pay for your care during the Deductible Period? (check all that apply)',
    type: 'multiselect',
    options: [
      { id: 'income', value: 'From my income' },
      { id: 'savings-investments', value: 'From my savings/Investments' },
      { id: 'family', value: 'My Family will pay' },
    ],
  },

  personalWorksheetAssetsWorth: {
    id: 'personal-worksheet-assets-worth',
    questionRef: 'personalWorksheetAssetsWorth',
    title:
      'Not counting your home, about how much are all of your assets (your savings and investments) worth? (check one)',
    type: 'radio',
    options: [
      { id: 'under-30000', value: 'Under $30,000' },
      { id: '30000-50000', value: '$30,000 - $50,000' },
      { id: 'over-50000', value: 'Over $50,000' },
    ],
  },

  personalWorksheetAssetsChange: {
    id: 'personal-worksheet-assets-change',
    questionRef: 'personalWorksheetAssetsChange',
    title: 'Do you expect your assets to change over the next ten (10) years? (check one)',
    type: 'radio',
    options: [
      { id: 'no', value: 'No' },
      { id: 'increase', value: 'Yes, expect to increase' },
      { id: 'decrease', value: 'Yes, expect to decrease' },
    ],
  },

  personalWorksheetDisclosureConfirmation: {
    id: 'personal-worksheet-disclosure-confirmation',
    questionRef: 'personalWorksheetDisclosureConfirmation',
    title:
      'Check one: The answers to the questions above accurately describe my financial situation OR I choose not to complete this information (in Sections B and C)',
    type: 'radio',
    format: 'vertical',
    required: true,
    options: [
      {
        id: 'confirm-answers',
        value: 'The answers to the questions above accurately describe my financial situation',
      },
      {
        id: 'non-disclosure',
        value:
          'I choose not to complete this information (in Sections B and C), and I have signed the Verification of Financial Non-Disclosure',
      },
    ],
  },

  personalWorksheetDisclosureAgreement: {
    id: 'personal-worksheet-disclosure-agreement',
    questionRef: 'personalWorksheetDisclosureAgreement',
    title: 'I understand that the rates for this policy may increase in the future',
    type: 'multiselect',
    required: true,
    options: [
      {
        id: 'agree',
        value:
          '(THIS CIRCLE MUST BE CHECKED) I agree that the Company and/or its Agent/Producer has reviewed this worksheet with me including the premium, premium increase history, and potential for premium increases in the future.',
      },
    ],
  },

  // Page 19 (Verification of Financial Non-Disclosure)
  financialNonDisclosureDecision: {
    id: 'financial-non-disclosure-decision',
    questionRef: 'financialNonDisclosureDecision',
    title: 'Please check below and return this form with your signed Personal Worksheet',
    type: 'radio',
    format: 'vertical',
    options: [
      {
        id: 'yes-proceed',
        value:
          'Yes, I wish to purchase this coverage. I still choose not to complete the financial information required in the Long Term Care Insurance Personal Worksheet. Please proceed with your review of my application.',
      },
      {
        id: 'no-decline',
        value: 'No, I have decided not to buy a policy at this time.',
      },
    ],
    conditional: {
      visible: {
        field: 'personalWorksheetDisclosureConfirmation',
        operator: 'equals',
        value: 'non-disclosure',
      },
      required: {
        field: 'personalWorksheetDisclosureConfirmation',
        operator: 'equals',
        value: 'non-disclosure',
      },
    },
  },

  personalWorksheetNotSuitable: {
    id: 'personal-worksheet-not-suitable',
    questionRef: 'personalWorksheetNotSuitable',
    title:
      'My Agent/Producer has advised me that this policy does not seem to be suitable for me. However, I still want the company to consider my application.',
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  // Page 20 (Long-Term Insurance Potential Rate Increase Disclosure Form)
  premiumAmount: {
    id: 'premium-amount',
    questionRef: 'premiumAmount',
    title: 'What is your premium?',
    type: 'text',
    required: true,
    validationType: 'currency',
  },

  // Page 22 (Licensed Insurance Producer Information)
  producerInfoPolicyNumber: {
    id: 'producer-info-policy-number',
    questionRef: 'producerInfoPolicyNumber',
    title: 'Policy Number',
    type: 'text',
  },

  producerInfoName: {
    id: 'producer-info-name',
    questionRef: 'producerInfoName',
    title: 'Name',
    type: 'text',
    required: true,
  },

  producerInfoStreetAddress: {
    id: 'producer-info-street-address',
    questionRef: 'producerInfoStreetAddress',
    title: 'Street Address',
    type: 'text',
    validationType: 'streetAddress',
    required: true,
  },

  producerInfoCity: {
    id: 'producer-info-city',
    questionRef: 'producerInfoCity',
    title: 'City',
    type: 'text',
    validationType: 'city',
    required: true,
  },

  producerInfoState: {
    id: 'producer-info-state',
    questionRef: 'producerInfoState',
    title: 'State',
    type: 'text',
    validationType: 'state',
    placeholder: 'Select state',
    required: true,
  },

  producerInfoZipcode: {
    id: 'producer-info-zipcode',
    questionRef: 'producerInfoZipcode',
    title: 'Zip Code',
    type: 'text',
    validationType: 'zipcode',
    required: true,
  },

  producerInfoLicenseOrTin: {
    id: 'producer-info-license-or-tin',
    questionRef: 'producerInfoLicenseOrTin',
    title: 'Licensed Insurance Producer # or SSN/TIN (last four only)',
    type: 'text',
    required: true,
  },

  producerInfoPhone: {
    id: 'producer-info-phone',
    questionRef: 'producerInfoPhone',
    title: 'Phone Number',
    type: 'text',
    validationType: 'phone',
    required: true,
  },

  producerInfoEmail: {
    id: 'producer-info-email',
    questionRef: 'producerInfoEmail',
    title: 'Email',
    type: 'text',
    validationType: 'email',
    required: true,
  },

  producerInfoBrokerageAgency: {
    id: 'producer-info-brokerage-agency',
    questionRef: 'producerInfoBrokerageAgency',
    title: 'Name of Licensed Brokerage General Agency (if applicable)',
    type: 'text',
  },

  producerInfoProducerCode: {
    id: 'producer-info-producer-code',
    questionRef: 'producerInfoProducerCode',
    title: 'Producer Code # or Brokerage General Agency Code #',
    type: 'text',
  },

  producerInfoCommissionSplit: {
    id: 'producer-info-commission-split',
    questionRef: 'producerInfoCommissionSplit',
    title: 'Commission Split Producer Information (if applicable)',
    type: 'table',
    minRows: 1,
    maxRows: 4,
    required: false,
    columns: [
      {
        id: 'producerName',
        title: 'Licensed Insurance Producer Name',
        type: 'text',
        required: false,
      },
      {
        id: 'producerTin',
        title: 'Producer # or SSN/TIN (last four only)',
        type: 'text',
        required: false,
      },
      {
        id: 'bgaCode',
        title: 'BGA Name/Code',
        type: 'text',
      },
      {
        id: 'percentage',
        title: '%',
        type: 'number',
      },
    ],
  },
  nameAndAddressOfProducer: {
    id: 'name-and-address-of-producer',
    questionRef: 'nameAndAddressOfProducer',
    title: 'Print Name and Address of Insurance Producer or Agent',
    type: 'text',
    composite: {
      questionRefs: [
        'producerInfoName',
        'producerInfoStreetAddress',
        'producerInfoCity',
        'producerInfoState',
        'producerInfoZipcode',
      ],
      delimiter: ', ',
    },
    disabled: true,
    hidden: true,
  },
};
